import { 
  LOAD_REMOTE_DEVICE_DATA_IN_PROGRESS,
  LOAD_REMOTE_DEVICE_DATA_SUCCESS,
  LOAD_REMOTE_DEVICE_DATA_FAILURE, 
  REMOTE_DEVICE_OPERATION_COMPLETED
} from "./actions";

const initialState = { isLoading: false, remoteDeviceList: [] };

export const remoteDeviceData= (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {    
    case LOAD_REMOTE_DEVICE_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        remoteDeviceList: data,
      };
    }
    case LOAD_REMOTE_DEVICE_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_REMOTE_DEVICE_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case REMOTE_DEVICE_OPERATION_COMPLETED:
      return {
          ...state,
          isLoading: false,
      }; 
    default:
     return state;
  }
};
